<template>
    <NuxtUiApp :locale="ru">
        <section class="fixed inset-0">
			<div class="flex items-center justify-center w-full h-full">
				<div class="flex flex-col gap-4">
					<div class="items-center self-center">
						<div class="inline-flex items-center gap-4 text-error">
							<h1 class="h1">{{ error.statusCode }}</h1>
							<p class="h3">{{ error.statusMessage || 'Server Error' }}</p>
						</div>
					</div>
					
					<NuxtUiButton color="primary" variant="soft" class="w-auto h-12 self-center" @click="handleError">Вернуться назад</NuxtUiButton>
				</div>
			</div>
        </section>
    </NuxtUiApp>
</template>

<script setup lang="ts">
import { ru } from '@nuxt/ui/locale'

const props = defineProps({
  	error: {
        type: Object,
        default: () => {}
    }
})

const router = useRouter()

const handleError = () => {
	clearError()
	router.back()
}

useSeoMeta({
	title: `${props.error.statusCode} — ${props.error.message}`,
	description: `${props.error.statusCode} — ${props.error.message}.`,
})
</script>